import { alpha, rgbToHex, Theme } from "@mui/material/styles";
import { BAR_FILL_ALPHA } from "../general/dataAtoms/shared";
import { getColorForCosts } from "./CostColors";
import { GraphColors, GraphTone } from "./graphDot";

/** How strongly a wash takes the colour of its tone, as a badge does. */
const WASH_ALPHA = 0.12;

// graphviz reads #rrggbb and #rrggbbaa, the theme may hold rgb() and rgba()
const hex = (color: string) => rgbToHex(color);

/**
 * The colours of the theme as graphviz can read them, for the graphs of the
 * dev tools: the same tokens the pages are styled with, so a graph follows a
 * user's own palette as the pages do.
 */
export function graphColors(theme: Theme): GraphColors {
  const { palette } = theme;
  const tone = (main: string, dark: string): GraphTone => ({
    ink: hex(dark),
    wash: hex(alpha(main, WASH_ALPHA)),
  });
  return {
    ink: hex(palette.text.primary),
    quiet: hex(palette.text.secondary),
    border: hex(alpha(palette.text.primary, 0.23)),
    rule: hex(palette.divider),
    surface: hex(palette.background.paper),
    soft: hex(palette.action.hover),
    arrow: hex(alpha(palette.text.primary, BAR_FILL_ALPHA)),
    primary: hex(palette.primary.main),
    incurred: hex(getColorForCosts("incurred", theme).backgroundColor),
    estimated: hex(getColorForCosts("estimated", theme).backgroundColor),
    favourable: tone(palette.data.positive.main, palette.data.positive.dark),
    adverse: tone(palette.data.negative.main, palette.data.negative.dark),
    warning: tone(palette.warning.main, palette.warning.dark),
    neutral: {
      ink: hex(palette.text.secondary),
      wash: hex(palette.action.hover),
    },
  };
}
